import { LanguageEnum } from '../../utils';

export const vchartCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部图表',
    [LanguageEnum.english]: 'All Charts',
  },
  name: {
    [LanguageEnum.chinese]: '按名称',
    [LanguageEnum.english]: 'Name',
  },
  target: {
    [LanguageEnum.chinese]: '按目的',
    [LanguageEnum.english]: 'Target',
  },
  shape: {
    [LanguageEnum.chinese]: '按形状',
    [LanguageEnum.english]: 'Shape',
  },
  component: {
    [LanguageEnum.chinese]: '按组件',
    [LanguageEnum.english]: 'Component',
  },
  //目的
  comparison: {
    [LanguageEnum.chinese]: '比较',
    [LanguageEnum.english]: 'Comparison',
  },
  trend: {
    [LanguageEnum.chinese]: '趋势',
    [LanguageEnum.english]: 'Trend',
  },
  composition: {
    [LanguageEnum.chinese]: '组成',
    [LanguageEnum.english]: 'Composition',
  },
  proportion: {
    [LanguageEnum.chinese]: '占比',
    [LanguageEnum.english]: 'Proportion',
  },
  distribution: {
    [LanguageEnum.chinese]: '分布',
    [LanguageEnum.english]: 'Distribution',
  },
  rank: {
    [LanguageEnum.chinese]: '排名',
    [LanguageEnum.english]: 'Rank',
  },
  relationship: {
    [LanguageEnum.chinese]: '关系',
    [LanguageEnum.english]: 'Relationship',
  },
  space: {
    [LanguageEnum.chinese]: '空间',
    [LanguageEnum.english]: 'Space',
  },
  //形状
  rectangle: {
    [LanguageEnum.chinese]: '矩形',
    [LanguageEnum.english]: 'Rectangle',
  },
  circle: {
    [LanguageEnum.chinese]: '圆形',
    [LanguageEnum.english]: 'Circle',
  },
  strip: {
    [LanguageEnum.chinese]: '条',
    [LanguageEnum.english]: 'Stripe',
  },
  scatter: {
    [LanguageEnum.chinese]: '点',
    [LanguageEnum.english]: 'Scatter',
  },
  area: {
    [LanguageEnum.chinese]: '面',
    [LanguageEnum.english]: 'Area',
  },
  triangle: {
    [LanguageEnum.chinese]: '三角形',
    [LanguageEnum.english]: 'Triangle',
  },
  polygon: {
    [LanguageEnum.chinese]: '多边形',
    [LanguageEnum.english]: 'Polygon',
  },
  line: {
    [LanguageEnum.chinese]: '线',
    [LanguageEnum.english]: 'Line',
  },
  pattern: {
    [LanguageEnum.chinese]: '纹理',
    [LanguageEnum.english]: 'Pattern',
  },
  flow: {
    [LanguageEnum.chinese]: '流',
    [LanguageEnum.english]: 'Flow',
  },
  text: {
    [LanguageEnum.chinese]: '文本',
    [LanguageEnum.english]: 'Text',
  },
  custom: {
    [LanguageEnum.chinese]: '自定义',
    [LanguageEnum.english]: 'Custom',
  },
  //组件
  axis: {
    [LanguageEnum.chinese]: '轴',
    [LanguageEnum.english]: 'Axis',
  },
  legend: {
    [LanguageEnum.chinese]: '图例',
    [LanguageEnum.english]: 'Legend',
  },
  marker: {
    [LanguageEnum.chinese]: '标注',
    [LanguageEnum.english]: 'Marker',
  },
  tooltip: {
    [LanguageEnum.chinese]: '提示信息',
    [LanguageEnum.english]: 'Tooltip',
  },
  animation: {
    [LanguageEnum.chinese]: '动画',
    [LanguageEnum.english]: 'Animation',
  },
  brush: {
    [LanguageEnum.chinese]: '框选',
    [LanguageEnum.english]: 'Brush',
  },
  crosshair: {
    [LanguageEnum.chinese]: '十字准星',
    [LanguageEnum.english]: 'Crosshair',
  },
  customMark: {
    [LanguageEnum.chinese]: '自定义图元',
    [LanguageEnum.english]: 'Custom Mark',
  },
  dataZoom: {
    [LanguageEnum.chinese]: '缩略轴',
    [LanguageEnum.english]: 'Data Zoom',
  },
  scrollbar: {
    [LanguageEnum.chinese]: '滚动条',
    [LanguageEnum.english]: 'Scrollbar',
  },
  indicator: {
    [LanguageEnum.chinese]: '指标卡',
    [LanguageEnum.english]: 'Indicator',
  },
  label: {
    [LanguageEnum.chinese]: '标签',
    [LanguageEnum.english]: 'Label',
  },
  mapLabel: {
    [LanguageEnum.chinese]: '地图标签',
    [LanguageEnum.english]: 'Map Label',
  },
  player: {
    [LanguageEnum.chinese]: '播放器',
    [LanguageEnum.english]: 'Player',
  },
  title: {
    [LanguageEnum.chinese]: '标题',
    [LanguageEnum.english]: 'Title',
  },
  data: {
    [LanguageEnum.chinese]: '数据',
    [LanguageEnum.english]: 'Data',
  },
  //图表名称
  areaChart: {
    [LanguageEnum.chinese]: '面积图',
    [LanguageEnum.english]: 'Area Chart',
  },
  barChart: {
    [LanguageEnum.chinese]: '柱状图',
    [LanguageEnum.english]: 'Bar Chart',
  },
  scatterChart: {
    [LanguageEnum.chinese]: '散点图',
    [LanguageEnum.english]: 'Scatter Plot',
  },
  roseChart: {
    [LanguageEnum.chinese]: '玫瑰图',
    [LanguageEnum.english]: 'Rose Chart',
  },
  lineChart: {
    [LanguageEnum.chinese]: '折线图',
    [LanguageEnum.english]: 'Line Chart',
  },
  boxPlot: {
    [LanguageEnum.chinese]: '箱形图',
    [LanguageEnum.english]: 'Box Plot',
  },
  circlePacking: {
    [LanguageEnum.chinese]: '嵌套圆图',
    [LanguageEnum.english]: 'Circle Packing',
  },
  commonChart: {
    [LanguageEnum.chinese]: '组合图',
    [LanguageEnum.english]: 'Common Chart',
  },
  radarChart: {
    [LanguageEnum.chinese]: '雷达图',
    [LanguageEnum.english]: 'Radar Chart',
  },
  polarChart: {
    [LanguageEnum.chinese]: '极坐标图',
    [LanguageEnum.english]: 'Polar Chart',
  },
  rangeColumnChart: {
    [LanguageEnum.chinese]: '区间柱图',
    [LanguageEnum.english]: 'Range Column Chart',
  },
  rangeColumn: {
    [LanguageEnum.chinese]: '区间柱图',
    [LanguageEnum.english]: 'Range Column Chart',
  },
  funnelChart: {
    [LanguageEnum.chinese]: '漏斗图',
    [LanguageEnum.english]: 'Funnel Chart',
  },
  histogram: {
    [LanguageEnum.chinese]: '直方图',
    [LanguageEnum.english]: 'Histogram Chart',
  },
  pieChart: {
    [LanguageEnum.chinese]: '饼图',
    [LanguageEnum.english]: 'Pie Chart',
  },
  map: {
    [LanguageEnum.chinese]: '地图',
    [LanguageEnum.english]: 'Map',
  },
  sankey: {
    [LanguageEnum.chinese]: '桑基图',
    [LanguageEnum.english]: 'Sankey Chart',
  },
  sequence: {
    [LanguageEnum.chinese]: '时序图',
    [LanguageEnum.english]: 'Sequence Chart',
  },
  circularProgress: {
    [LanguageEnum.chinese]: '环形进度图',
    [LanguageEnum.english]: 'Circular Progress Chart',
  },
  sunburst: {
    [LanguageEnum.chinese]: '旭日图',
    [LanguageEnum.english]: 'Sunburst Chart',
  },
  treemap: {
    [LanguageEnum.chinese]: '矩形树图',
    [LanguageEnum.english]: 'Treemap',
  },
  waterfall: {
    [LanguageEnum.chinese]: '瀑布图',
    [LanguageEnum.english]: 'Waterfall Chart',
  },
  wordCloud: {
    [LanguageEnum.chinese]: '词云',
    [LanguageEnum.english]: 'Word Cloud',
  },
  gauge: {
    [LanguageEnum.chinese]: '仪表盘图',
    [LanguageEnum.english]: 'Gauge Chart',
  },
  linearProgress: {
    [LanguageEnum.chinese]: '条形进度图',
    [LanguageEnum.english]: 'Linear Progress Chart',
  },
  heatmap: {
    [LanguageEnum.chinese]: '热图',
    [LanguageEnum.english]: 'Heatmap',
  },
  streamgraph: {
    [LanguageEnum.chinese]: '河流图',
    [LanguageEnum.english]: 'Stream Graph',
  },
  //VChart Group
  'line chart': {
    [LanguageEnum.chinese]: '折线图',
    [LanguageEnum.english]: 'Line Chart',
  },
  'area chart': {
    [LanguageEnum.chinese]: '面积图',
    [LanguageEnum.english]: 'Area Chart',
  },
  'bar chart': {
    [LanguageEnum.chinese]: '柱状图',
    [LanguageEnum.english]: 'Bar Chart',
  },
  'histogram chart': {
    [LanguageEnum.chinese]: '直方图',
    [LanguageEnum.english]: 'Histogram Chart',
  },
  'range column chart': {
    [LanguageEnum.chinese]: '区间柱图',
    [LanguageEnum.english]: 'Range Column Chart',
  },
  'box plot': {
    [LanguageEnum.chinese]: '箱形图',
    [LanguageEnum.english]: 'Box Plot',
  },
  pie: {
    [LanguageEnum.chinese]: '饼图',
    [LanguageEnum.english]: 'Pie Chart',
  },
  rose: {
    [LanguageEnum.chinese]: '玫瑰图',
    [LanguageEnum.english]: 'Rose Chart',
  },
  'funnel chart': {
    [LanguageEnum.chinese]: '漏斗图',
    [LanguageEnum.english]: 'Funnel Chart',
  },
  'scatter chart': {
    [LanguageEnum.chinese]: '散点图',
    [LanguageEnum.english]: 'Scatter Plot',
  },
  'radar chart': {
    [LanguageEnum.chinese]: '雷达图',
    [LanguageEnum.english]: 'Radar Chart',
  },
  'map chart': {
    [LanguageEnum.chinese]: '地图',
    [LanguageEnum.english]: 'Map',
  },
  'sankey chart': {
    [LanguageEnum.chinese]: '桑基图',
    [LanguageEnum.english]: 'Sankey Chart',
  },
  'sequence chart': {
    [LanguageEnum.chinese]: '时序图',
    [LanguageEnum.english]: 'Sequence Chart',
  },
  'word chart': {
    [LanguageEnum.chinese]: '词云',
    [LanguageEnum.english]: 'Word Cloud',
  },
  progress: {
    [LanguageEnum.chinese]: '进度图',
    [LanguageEnum.english]: 'Progress Chart',
  },
  'liquid chart': {
    [LanguageEnum.chinese]: '水波图',
    [LanguageEnum.english]: 'Liquid Chart',
  },
  liquidChart: {
    [LanguageEnum.chinese]: '水波图',
    [LanguageEnum.english]: 'Liquid Chart',
  },
  'venn chart': {
    [LanguageEnum.chinese]: '韦恩图',
    [LanguageEnum.english]: 'Venn Chart',
  },
  vennChart: {
    [LanguageEnum.chinese]: '韦恩图',
    [LanguageEnum.english]: 'Venn Chart',
  },
  'treemap chart': {
    [LanguageEnum.chinese]: '树图',
    [LanguageEnum.english]: 'Treemap',
  },
  'heatmap chart': {
    [LanguageEnum.chinese]: '热图',
    [LanguageEnum.english]: 'Heatmap',
  },
  CirclePacking: {
    [LanguageEnum.chinese]: '嵌套圆图',
    [LanguageEnum.english]: 'Circle Packing',
  },
  'sunburst chart': {
    [LanguageEnum.chinese]: '旭日图',
    [LanguageEnum.english]: 'Sunburst Chart',
  },
  'correlation chart': {
    [LanguageEnum.chinese]: '散点相关性图',
    [LanguageEnum.english]: 'Correlation Chart',
  },
  combination: {
    [LanguageEnum.chinese]: '组合图',
    [LanguageEnum.english]: 'Combination Chart',
  },
  'pivot chart': {
    [LanguageEnum.chinese]: '透视图',
    [LanguageEnum.english]: 'Pivot Chart',
  },
  'gantt chart': {
    [LanguageEnum.chinese]: '甘特图',
    [LanguageEnum.english]: 'Gantt Chart',
  },
  'calendar chart': {
    [LanguageEnum.chinese]: '日历图',
    [LanguageEnum.english]: 'Calendar Chart',
  },
  pivotChart: {
    [LanguageEnum.chinese]: '透视图',
    [LanguageEnum.english]: 'Pivot Chart',
  },
  ganttChart: {
    [LanguageEnum.chinese]: '甘特图',
    [LanguageEnum.english]: 'Gantt Chart',
  },
  calendarChart: {
    [LanguageEnum.chinese]: '日历图',
    [LanguageEnum.english]: 'Calendar Chart',
  },
  'extension chart': {
    [LanguageEnum.chinese]: '拓展图表',
    [LanguageEnum.english]: 'Extension Chart',
  },
  'chart-3d': {
    [LanguageEnum.chinese]: '三维图',
    [LanguageEnum.english]: '3D Chart',
  },
  'data-zoom': {
    [LanguageEnum.chinese]: '缩略轴',
    [LanguageEnum.english]: 'Data Zoom',
  },
  scrollBar: {
    [LanguageEnum.chinese]: '滚动条',
    [LanguageEnum.english]: 'Scrollbar',
  },
  storytelling: {
    [LanguageEnum.chinese]: '动画 & 叙事',
    [LanguageEnum.english]: 'Animation & Storytelling',
  },
  vscreen: {
    [LanguageEnum.chinese]: '大屏可视化',
    [LanguageEnum.english]: 'VScreen Visualization',
  },
  layout: {
    [LanguageEnum.chinese]: '布局',
    [LanguageEnum.english]: 'Layout',
  },
  gradient: {
    [LanguageEnum.chinese]: '渐变色',
    [LanguageEnum.english]: 'Gradient',
  },
  theme: {
    [LanguageEnum.chinese]: '主题',
    [LanguageEnum.english]: 'Theme',
  },
  interaction: {
    [LanguageEnum.chinese]: '交互',
    [LanguageEnum.english]: 'Interaction',
  },
  'mosaic chart': {
    [LanguageEnum.chinese]: '马赛克图',
    [LanguageEnum.english]: 'Mosaic Chart',
  },
  mosaicChart: {
    [LanguageEnum.chinese]: '马赛克图',
    [LanguageEnum.english]: 'Mosaic Chart',
  },
  'pictogram chart': {
    [LanguageEnum.chinese]: '象形图',
    [LanguageEnum.english]: 'Pictogram Chart',
  },
  pictogramChart: {
    [LanguageEnum.chinese]: '象形图',
    [LanguageEnum.english]: 'Pictogram Chart',
  },
  'candlestick chart': {
    [LanguageEnum.chinese]: '蜡烛图',
    [LanguageEnum.english]: 'Candlestick Chart',
  },
  candlestickChart: {
    [LanguageEnum.chinese]: '蜡烛图',
    [LanguageEnum.english]: 'Candlestick Chart',
  },
  'candlestick-chart': {
    [LanguageEnum.chinese]: '蜡烛图',
    [LanguageEnum.english]: 'Candlestick Chart',
  },
};

// 'gauge': {
//   [LanguageEnum.chinese]: '仪表盘图',
//   [LanguageEnum.english]: 'Gauge Chart',
// },
//   'waterfall',
// 'title',
// 'axis',
// 'tooltip',
// 'legend',
// 'crosshair',
// 'player',
// 'brush',
// 'marker',
// 'data',
// 'label',
// 'layout',
// 'customMark',
// 'pattern';

export const vgrammarCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  //VGrammar Group
  allCharts: {
    [LanguageEnum.chinese]: '全部可视化',
    [LanguageEnum.english]: 'All Visualization',
  },
  'basic-mark-rect': {
    [LanguageEnum.chinese]: '矩形基础图元',
    [LanguageEnum.english]: 'Basic Mark Rect',
  },
  'basic-mark-line': {
    [LanguageEnum.chinese]: '线基础图元',
    [LanguageEnum.english]: 'Basic Mark Line',
  },
  'basic-mark-area': {
    [LanguageEnum.chinese]: '面积基础图元',
    [LanguageEnum.english]: 'Basic Mark Area',
  },
  'basic-mark-arc': {
    [LanguageEnum.chinese]: '弧形基础图元',
    [LanguageEnum.english]: 'Basic Mark Arc',
  },
  'basic-mark-symbol': {
    [LanguageEnum.chinese]: '符号基础图元',
    [LanguageEnum.english]: 'Basic Mark Symbol',
  },
  'basic-mark-rule': {
    [LanguageEnum.chinese]: '连线基础图元',
    [LanguageEnum.english]: 'Basic Mark Rule',
  },
  'basic-mark-polygon': {
    [LanguageEnum.chinese]: '多边形基础图元',
    [LanguageEnum.english]: 'Basic Mark Polygon',
  },
  'basic-mark-circle': {
    [LanguageEnum.chinese]: '圆形基础图元',
    [LanguageEnum.english]: 'Basic Mark Circle',
  },
  'basic-mark-text': {
    [LanguageEnum.chinese]: '文本基础图元',
    [LanguageEnum.english]: 'Basic Mark Text',
  },
  'basic-mark-richtext': {
    [LanguageEnum.chinese]: '富文本基础图元',
    [LanguageEnum.english]: 'Basic Mark Richtext',
  },
  'basic-mark-image': {
    [LanguageEnum.chinese]: '图像基础图元',
    [LanguageEnum.english]: 'Basic Mark Image',
  },
  'mark-cell': {
    [LanguageEnum.chinese]: '单元图元',
    [LanguageEnum.english]: 'Mark Cell',
  },
  'mark-interval': {
    [LanguageEnum.chinese]: '区间图元',
    [LanguageEnum.english]: 'Mark Interval',
  },
  'glyph-mark': {
    [LanguageEnum.chinese]: '组合图元',
    [LanguageEnum.english]: 'Glyph Mark',
  },
  '3d-mark': {
    [LanguageEnum.chinese]: '三维图元',
    [LanguageEnum.english]: '3D Mark',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  animate: {
    [LanguageEnum.chinese]: '动画',
    [LanguageEnum.english]: 'Animate',
  },
  'hierarchy-circlePacking': {
    [LanguageEnum.chinese]: '层级嵌套圆图',
    [LanguageEnum.english]: 'Hierarchy Circle Packing',
  },
  'hierarchy-sunburst': {
    [LanguageEnum.chinese]: '旭日图',
    [LanguageEnum.english]: 'Hierarchy Sunburst',
  },
  hierarchy: {
    [LanguageEnum.chinese]: '层级图表',
    [LanguageEnum.english]: 'Hierarchy',
  },
  sankey: {
    [LanguageEnum.chinese]: '桑基图',
    [LanguageEnum.english]: 'Sankey',
  },
  wordcloud: {
    [LanguageEnum.chinese]: '词云',
    [LanguageEnum.english]: 'Word Cloud',
  },
  'wordcloud-shape': {
    [LanguageEnum.chinese]: '形状词云',
    [LanguageEnum.english]: 'Shape Word Cloud',
  },
  perf: {
    [LanguageEnum.chinese]: '性能',
    [LanguageEnum.english]: 'Performance',
  },
};

export const vtableCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部表格',
    [LanguageEnum.english]: 'All Tables',
  },
  performace: {
    [LanguageEnum.chinese]: '性能',
    [LanguageEnum.english]: 'Performance',
  },
  edit: {
    [LanguageEnum.chinese]: '编辑',
    [LanguageEnum.english]: 'Edit',
  },
  export: {
    [LanguageEnum.chinese]: '表格导出',
    [LanguageEnum.english]: 'Table Export',
  },
  'Table Type': {
    [LanguageEnum.chinese]: '表格类型',
    [LanguageEnum.english]: 'Table Type',
  },
  'table-type': {
    [LanguageEnum.chinese]: '表格类型',
    [LanguageEnum.english]: 'Table Type',
  },
  'List Table': {
    [LanguageEnum.chinese]: '基本表格',
    [LanguageEnum.english]: 'List Table',
  },
  'Pivot Table': {
    [LanguageEnum.chinese]: '透视表',
    [LanguageEnum.english]: 'Pivot Table',
  },
  'Pivot Chart': {
    [LanguageEnum.chinese]: '透视图表',
    [LanguageEnum.english]: 'Pivot Chart',
  },
  'Cell Type': {
    [LanguageEnum.chinese]: '单元格类型',
    [LanguageEnum.english]: 'Cell Type',
  },
  'Basic Features': {
    [LanguageEnum.chinese]: '基本功能',
    [LanguageEnum.english]: 'Basic Features',
  },
  Interaction: {
    [LanguageEnum.chinese]: '交互',
    [LanguageEnum.english]: 'Interaction',
  },
  Style: {
    [LanguageEnum.chinese]: '风格',
    [LanguageEnum.english]: 'Style',
  },
  Theme: {
    [LanguageEnum.chinese]: '主题',
    [LanguageEnum.english]: 'Theme',
  },
  Custom: {
    [LanguageEnum.chinese]: '自定义',
    [LanguageEnum.english]: 'Custom',
  },
  Component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  Business: {
    [LanguageEnum.chinese]: '业务',
    [LanguageEnum.english]: 'Business',
  },
  'data-analysis': {
    [LanguageEnum.chinese]: '透视表数据分析',
    [LanguageEnum.english]: 'Pivot Table Data Analysis',
  },
  'list-table-data-analysis': {
    [LanguageEnum.chinese]: '普通表数据分析',
    [LanguageEnum.english]: 'List Table Data Analysis',
  },
  Animation: {
    [LanguageEnum.chinese]: '动画',
    [LanguageEnum.english]: 'Animation',
  },
  search: {
    [LanguageEnum.chinese]: '搜索',
    [LanguageEnum.english]: 'Search',
  },
  gantt: {
    [LanguageEnum.chinese]: '甘特图',
    [LanguageEnum.english]: 'Gantt',
  },
  Calendar: {
    [LanguageEnum.chinese]: '日历图',
    [LanguageEnum.english]: 'Calendar',
  },
  'vtable-sheet': {
    [LanguageEnum.chinese]: '电子表格',
    [LanguageEnum.english]: 'Spreatsheet',
  },
  plugin: {
    [LanguageEnum.chinese]: 'VTable插件',
    [LanguageEnum.english]: 'Plugins',
  },
};

export const vrenderCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部图形',
    [LanguageEnum.english]: 'All Graphics',
  },
  'graphic-arc': {
    [LanguageEnum.chinese]: '弧形图形',
    [LanguageEnum.english]: 'Graphic Arc',
  },
  'graphic-area': {
    [LanguageEnum.chinese]: '面图形',
    [LanguageEnum.english]: 'Graphic Area',
  },
  'graphic-circle': {
    [LanguageEnum.chinese]: '圆形图形',
    [LanguageEnum.english]: 'Graphic Circle',
  },
  'graphic-rect': {
    [LanguageEnum.chinese]: '矩形图形',
    [LanguageEnum.english]: 'Graphic Rect',
  },
  'graphic-path': {
    [LanguageEnum.chinese]: '路径图形',
    [LanguageEnum.english]: 'Graphic Path',
  },
  'graphic-symbol': {
    [LanguageEnum.chinese]: '符号图形',
    [LanguageEnum.english]: 'Graphic Symbol',
  },
  'graphic-line': {
    [LanguageEnum.chinese]: '线图形',
    [LanguageEnum.english]: 'Graphic Line',
  },
  'graphic-glyph': {
    [LanguageEnum.chinese]: 'Glyph图形',
    [LanguageEnum.english]: 'Graphic Glyph',
  },
  'graphic-text': {
    [LanguageEnum.chinese]: '文本图形',
    [LanguageEnum.english]: 'Graphic Text',
  },
  'graphic-richtext': {
    [LanguageEnum.chinese]: '富文本图形',
    [LanguageEnum.english]: 'Graphic Richtext',
  },
  effects: {
    [LanguageEnum.chinese]: '效果',
    [LanguageEnum.english]: 'effects',
  },
};

export const vchartReactCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部图表',
    [LanguageEnum.english]: 'All Charts',
  },
  usage: {
    [LanguageEnum.chinese]: '基础用法',
    [LanguageEnum.english]: 'Usage',
  },
  'grammatical-tag': {
    [LanguageEnum.chinese]: '语法标签',
    [LanguageEnum.english]: 'Grammatical Tag',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  event: {
    [LanguageEnum.chinese]: '事件',
    [LanguageEnum.english]: 'Event',
  },
  theme: {
    [LanguageEnum.chinese]: '主题',
    [LanguageEnum.english]: 'Theme',
  },
  'funnel chart': {
    [LanguageEnum.chinese]: '漏斗图',
    [LanguageEnum.english]: 'Funnel Chart',
  },
};

export const vchartOpeninulaCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部图表',
    [LanguageEnum.english]: 'All Charts',
  },
  usage: {
    [LanguageEnum.chinese]: '基础用法',
    [LanguageEnum.english]: 'Usage',
  },
  'grammatical-tag': {
    [LanguageEnum.chinese]: '语法标签',
    [LanguageEnum.english]: 'Grammatical Tag',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  event: {
    [LanguageEnum.chinese]: '事件',
    [LanguageEnum.english]: 'Event',
  },
  theme: {
    [LanguageEnum.chinese]: '主题',
    [LanguageEnum.english]: 'Theme',
  },
};

export const vtableReactCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部表格',
    [LanguageEnum.english]: 'All Tables',
  },
  usage: {
    [LanguageEnum.chinese]: '基础用法',
    [LanguageEnum.english]: 'Usage',
  },
  'grammatical-tag': {
    [LanguageEnum.chinese]: '语法标签',
    [LanguageEnum.english]: 'Grammatical Tag',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  event: {
    [LanguageEnum.chinese]: '事件',
    [LanguageEnum.english]: 'Event',
  },
  'functional-components': {
    [LanguageEnum.chinese]: '功能性组件',
    [LanguageEnum.english]: 'Functional Components',
  },
};

export const vtableVueCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部表格',
    [LanguageEnum.english]: 'All Tables',
  },
  usage: {
    [LanguageEnum.chinese]: '基础用法',
    [LanguageEnum.english]: 'Usage',
  },
  'grammatical-tag': {
    [LanguageEnum.chinese]: '语法标签',
    [LanguageEnum.english]: 'Grammatical Tag',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  event: {
    [LanguageEnum.chinese]: '事件',
    [LanguageEnum.english]: 'Event',
  },
  'functional-components': {
    [LanguageEnum.chinese]: '功能性组件',
    [LanguageEnum.english]: 'Functional Components',
  },
  custom: {
    [LanguageEnum.chinese]: '自定义',
    [LanguageEnum.english]: 'Custom',
  },
  'custom-layout': {
    [LanguageEnum.chinese]: '自定义布局',
    [LanguageEnum.english]: 'Custom Layout',
  },
  compilation: {
    [LanguageEnum.chinese]: '更多示例',
    [LanguageEnum.english]: 'Compilation',
  },
};

export const vtableOpeninulaCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部表格',
    [LanguageEnum.english]: 'All Tables',
  },
  usage: {
    [LanguageEnum.chinese]: '基础用法',
    [LanguageEnum.english]: 'Usage',
  },
  'grammatical-tag': {
    [LanguageEnum.chinese]: '语法标签',
    [LanguageEnum.english]: 'Grammatical Tag',
  },
  component: {
    [LanguageEnum.chinese]: '组件',
    [LanguageEnum.english]: 'Component',
  },
  event: {
    [LanguageEnum.chinese]: '事件',
    [LanguageEnum.english]: 'Event',
  },
  'functional-components': {
    [LanguageEnum.chinese]: '功能性组件',
    [LanguageEnum.english]: 'Functional Components',
  },
};

export const vgraphCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  allCharts: {
    [LanguageEnum.chinese]: '全部示例',
    [LanguageEnum.english]: 'All Examples',
  },
  solutions: {
    [LanguageEnum.chinese]: '图分析场景解决方案',
    [LanguageEnum.english]: 'Graph Analysis Solutions',
  },
  editor: {
    [LanguageEnum.chinese]: '图编辑场景解决方案',
    [LanguageEnum.english]: 'Graph Editor Solutions',
  },
  reactNodes: {
    [LanguageEnum.chinese]: 'React节点组件',
    [LanguageEnum.english]: 'React Node Components',
  },
  dag: {
    [LanguageEnum.chinese]: '有向图',
    [LanguageEnum.english]: 'DAG',
  },
  force: {
    [LanguageEnum.chinese]: '关系图',
    [LanguageEnum.english]: 'Relation Graph',
  },
  tree: {
    [LanguageEnum.chinese]: '树状图',
    [LanguageEnum.english]: 'Tree',
  },
  custom: {
    [LanguageEnum.chinese]: '自定义布局',
    [LanguageEnum.english]: 'Custom Layout',
  },
  nodes: {
    [LanguageEnum.chinese]: '节点',
    [LanguageEnum.english]: 'Nodes',
  },
  edges: {
    [LanguageEnum.chinese]: '连线',
    [LanguageEnum.english]: 'Edges',
  },
  groups: {
    [LanguageEnum.chinese]: '分组',
    [LanguageEnum.english]: 'Groups',
  },
  react: {
    [LanguageEnum.chinese]: 'React 组件',
    [LanguageEnum.english]: 'React Components',
  },
  plugins: {
    [LanguageEnum.chinese]: '原生组件',
    [LanguageEnum.english]: 'Native Components',
  },
  animate: {
    [LanguageEnum.chinese]: '动画',
    [LanguageEnum.english]: 'Animation',
  },
  behaviors: {
    [LanguageEnum.chinese]: '内置交互',
    [LanguageEnum.english]: 'Behaviors',
  },
  practiceCases: {
    [LanguageEnum.chinese]: '实践案例',
    [LanguageEnum.english]: 'Practice Cases',
  },
};

export const vstoryCopyWritings: Record<
  string,
  Record<LanguageEnum, string>
> = {
  'works-show': {
    [LanguageEnum.chinese]: '作品展示',
    [LanguageEnum.english]: 'works show',
  },
  animate: {
    [LanguageEnum.chinese]: '动画',
    [LanguageEnum.english]: 'animate',
  },
  character: {
    [LanguageEnum.chinese]: 'character 元素',
    [LanguageEnum.english]: 'character element',
  },
  arrange: {
    [LanguageEnum.chinese]: '动画编排',
    [LanguageEnum.english]: 'Animation arrangement',
  },
  templates: {
    [LanguageEnum.chinese]: '模板',
    [LanguageEnum.english]: 'templates',
  },
  infographic: {
    [LanguageEnum.chinese]: '信息图',
    [LanguageEnum.english]: 'Infographic',
  },
};

type copyWritingsMap = {
  [key: string]: Record<string, Record<LanguageEnum, string>>;
};

export const copyWritingsMap = {
  vchart: vchartCopyWritings,
  vgrammar: vgrammarCopyWritings,
  vtable: vtableCopyWritings,
  vgraph: vgraphCopyWritings,
  vrender: vrenderCopyWritings,
  vstory: vstoryCopyWritings,

  'vchart-react': vchartReactCopyWritings,
  'vchart-openinula': vchartOpeninulaCopyWritings,
  'vtable-react': vtableReactCopyWritings,
  'vtable-vue': vtableVueCopyWritings,
  'vtable-openinula': vtableOpeninulaCopyWritings,
};
